export default "__VITE_ASSET__d10b50ce__"